import { css, type Theme } from "@emotion/react";

export const user = (theme: Theme) => css`
  color: ${theme.success.textBase};
`;
